import React from 'react';

import styled from 'styled-components';

import { YouTubePlayer } from '../../../utils/loadablePlayers';

interface InlineYouTubePlayerProps {
  url: string;
  width?: string;
  height?: string;
  borderRadius?: string;
}

const VideoWrapper = styled.div<{ $width: string; $height: string; $borderRadius: string }>`
  position: relative;
  width: ${({ $width }) => $width};
  height: ${({ $height }) => $height};
  overflow: hidden;
  border-radius: ${({ $borderRadius }) => $borderRadius};
  .react-player {
    position: absolute;
    top: 0;
    left: 0;
  }
`;

const InlineYouTubePlayer: React.FC<InlineYouTubePlayerProps> = ({
  url,
  width = '100%',
  height = '100%',
  borderRadius = '0',
}) => {
  return (
    <VideoWrapper $width={width} $height={height} $borderRadius={borderRadius}>
      <YouTubePlayer
        url={url}
        width="100%"
        height="100%"
        playing={true}
        muted={true}
        loop={true}
        controls={false}
        playsinline={true}
        rel={0}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
        }}
      />
    </VideoWrapper>
  );
};

export default InlineYouTubePlayer;
